
import React, { useState } from 'react';
import { Language } from '../types';
import { translations } from '../translations';

interface FAQProps {
  lang: Language;
}

const FAQ: React.FC<FAQProps> = ({ lang }) => {
  const [openIndices, setOpenIndices] = useState<number[]>([]);
  const t = translations[lang].faq;

  const toggleFAQ = (index: number) => {
    setOpenIndices(prev => 
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  return (
    <section id="faq" className="py-32 bg-zinc-950">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-7xl font-bold mb-8 tracking-tighter text-white">{t.title}</h2>
          <p className="text-gray-400 text-xl md:text-2xl font-light">{t.subtitle}</p>
        </div>
        <div className="space-y-4">
          {t.items.map((item, index) => {
            const isOpen = openIndices.includes(index);
            return (
              <div key={index} className="card-dark overflow-hidden transition-all duration-300">
                <button onClick={() => toggleFAQ(index)} className="w-full px-8 py-6 flex justify-between items-center text-left hover:bg-white/[0.02] transition-colors">
                  <span className={`font-semibold text-lg transition-colors ${isOpen ? 'text-white' : 'text-gray-300'}`}>{item.q}</span>
                  <svg className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180 text-sky-400' : 'text-gray-500'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                </button>
                <div className={`px-8 overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <p className="text-gray-400 leading-relaxed text-lg">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
